<template>
  <div class="title">
    <div class="all_box">
      <div class="title_box">
        <div class="logo">
          <img src="../assets/logo.png" alt="" />
        </div>

        <div class="nav">
          <div class="nav_item" @click="routerLink('home')">首页</div>
          <div class="nav_item" @click="routerLink('serve')">服务介绍</div>
          <!-- <div class="nav_item" @click="routerLink('home')">睿兔家政</div> -->
          <div class="nav_item" @click="routerLink('join')">一键加盟</div>
          <div class="nav_item" @click="routerLink('joinRuitu')">加入睿兔</div>
          <div class="nav_item" @click="routerLink('joinUs')">加入我们</div>
          <div
            class="nav_item"
            @mouseenter="ziShow = true"
            @mouseleave="ziShow = false"
          >
            关于睿兔
            <div class="aboutZi" v-if="ziShow">
              <div class="aboutZi_item" @click="routerLink('contact')">
                联系睿兔跑腿
              </div>
              <div class="aboutZi_item" @click="routerLink('feedback')">
                意见反馈
              </div>
              <div class="aboutZi_item" @click="routerLink('about')">
                睿兔跑腿介绍
              </div>
            </div>
          </div>
        </div>
        <div class="add">
          <img src="../assets/add.png" />        {{ city }}
        </div>
        <div id="container"></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      ziShow: false,
      city: '',
    };
  },


  mounted(){
    AMap.plugin('AMap.CitySearch', ()=>{
      var citySearch = new AMap.CitySearch()
      citySearch.getLocalCity((status, result)=> {
        this.city = result.city
      })
  })
  },

  methods: {

    routerLink(name) {
      if (name == this.$route.name) {
        return;
      }
      this.$router.push({
        name: name,
      });
    },
    mouseOver() {
      this.ziShow = true;
    },
    mouseleave() {
      this.ziShow = false;
    },
  },
};
</script>


<style lang="scss" scoped>
img {
  display: block;
}
.all_box {
  width: 1380px;
  margin: 0 auto;
  position: relative;
}
.title {
  padding: 10px 0;
  background: #fff;
  .title_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .logo {
      width: 14%;
    }
    .nav {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      width: 70%;
      box-sizing: border-box;
      padding-right: 80px;
      .nav_item {
        cursor: pointer;
        width: 14%;
        position: relative;
        .aboutZi {
          position: absolute;
          z-index: 1000;
          background: #fff;
          padding: 6px;
          width: 110px;
          left: 10px;
          box-sizing: border-box;
          .aboutZi_item {
            padding: 10px 0;
          }
        }
      }
    }
    .add {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      width: 10%;
      img {
        margin-right: 5px;
      }
    }
  }
}
</style>